import { useEffect, useState } from "react";
import ReleaseDate from "../Archive/ReleaseDate";
import Duration from "../Archive/Duration";
import Playcount from "../Archive/Playcount";
import FavouriteCount from "../Archive/FavouriteCount";
import Description from "./Description";

const Drawer = (props) => {
  const {
    isMobile,
    drawerMix,
    setDrawerMix,
    drawerOpen,
    setDrawerOpen,
    setPlayingMix,
    setPlayerOpen,
  } = props;

  function replaceAfterLastHyphen(url) {
    const lastHyphenIndex = url.lastIndexOf("-");
    if (lastHyphenIndex === -1) return url;
    return url.slice(0, lastHyphenIndex + 1) + "t500x500.jpg";
  }

  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    if (drawerMix) {
      setImageUrl(replaceAfterLastHyphen(drawerMix.artworkUrl));
    }
  }, [drawerMix]);

  return (
    <aside className={`drawer__wrapper ${drawerOpen ? "active" : ""}`}>
      <button
        className="ra__button drawer__close"
        onClick={() => {
          setDrawerMix(null);
          setDrawerOpen(false);
        }}
      >
        <span className="ra__arrow">&rarr;</span>
      </button>
      {drawerMix ? (
        <>
          <div className="drawer__cover-wrapper">
            <img
              className="drawer__cover"
              src={imageUrl}
              alt={`${drawerMix.title}`}
            />
          </div>
          <div className="drawer__section">
            <h2>
              RA.{drawerMix.mixNumber < 1000?"0":""}{drawerMix.mixNumber} / {drawerMix.artistName}
            </h2>
          </div>
          <div className="drawer__section">
            <button
              className="ra__button listen"
              onClick={() => {
                setPlayingMix(drawerMix);
                setPlayerOpen(true);
              }}
            >
              Listen
            </button>
          </div>
          <div className="drawer__section">
            {drawerMix.releaseDate ? "Released: " : ""}
            {drawerMix.releaseDate ? (
              <>
                <ReleaseDate
                  mix={drawerMix}
                  date={drawerMix.releaseDate}
                  isMobile={isMobile}
                />
                <br />
              </>
            ) : (
              ""
            )}
            Duration: <Duration duration={drawerMix.duration} />
            <br />
            Listens: <Playcount playcount={drawerMix.playbackCount} />
            <br />
            Likes: <FavouriteCount favs={drawerMix.likesCount} />
          </div>

          <div className="drawer__section">
            <Description content={drawerMix.description} />
          </div>
        </>
      ) : (
        <div className="drawer-cover-wrapper">Loading...</div>
      )}
    </aside>
  );
};

export default Drawer;
